import * as THREE from 'three';

export class EngineGlow {
  private glowMesh: THREE.Mesh;
  private intensity: number;
  private targetIntensity: number;
  private pulseSpeed: number;
  private pulsePhase: number;

  constructor(parentMesh: THREE.Mesh) {
    this.intensity = 0;
    this.targetIntensity = 1.0;
    this.pulseSpeed = 2.0;
    this.pulsePhase = 0;
    
    // Create glow geometry
    const geometry = new THREE.SphereGeometry(0.3, 8, 8);
    
    // Create glow material
    const material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 0.8,
      blending: THREE.AdditiveBlending
    });
    
    this.glowMesh = new THREE.Mesh(geometry, material);
    this.glowMesh.position.set(0, 0, -0.5); // Position at rear of ship
    parentMesh.add(this.glowMesh);
  }

  public setIntensity(intensity: number): void {
    this.targetIntensity = intensity;
  }

  public update(deltaTime: number): void {
    // Smooth intensity transitions
    this.intensity += (this.targetIntensity - this.intensity) * deltaTime * 5.0;
    
    // Add pulsing effect
    this.pulsePhase += deltaTime * this.pulseSpeed;
    const pulse = 0.8 + Math.sin(this.pulsePhase) * 0.2;
    
    // Update glow appearance
    const finalIntensity = this.intensity * pulse;
    this.glowMesh.scale.setScalar(0.5 + finalIntensity * 0.5);
    
    if (this.glowMesh.material instanceof THREE.MeshBasicMaterial) {
      this.glowMesh.material.opacity = finalIntensity * 0.8;
    }
    
    this.glowMesh.visible = this.intensity > 0.01;
  }

  public setColor(color: THREE.Color): void {
    if (this.glowMesh.material instanceof THREE.MeshBasicMaterial) {
      this.glowMesh.material.color.copy(color);
    }
  }

  public dispose(): void {
    if (this.glowMesh.parent) {
      this.glowMesh.parent.remove(this.glowMesh);
    }
    
    if (this.glowMesh.geometry) {
      this.glowMesh.geometry.dispose();
    }
    
    if (this.glowMesh.material) {
      if (Array.isArray(this.glowMesh.material)) {
        this.glowMesh.material.forEach(mat => mat.dispose());
      } else {
        this.glowMesh.material.dispose();
      }
    }
  }
}